import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Component, OnDestroy } from '@angular/core';


@Component({
    selector: 'btn-cell-renderer-masterGrid',
    template: `
		<em *ngIf="enableEdit">
		<img style="cursor:pointer;"
		src="./assets/images/edit_blue.svg" 
		(click)="btnClickedHandler('edit')"> 
		</em>`,
    standalone: false
})
export class BtnCellRenderermasterGrid implements ICellRendererAngularComp, OnDestroy {



	refresh(params: ICellRendererParams): boolean {
		throw new Error(`Error while refreshing renderer component. INFO-${params}`);
	}

	private params: any;
	pageName;
	enableEdit: boolean = false;
	// enableDelete: boolean = false;

	agInit(params: any): void {

		this.params = params;
		this.pageName = this.params.colDef.field;
		this.enableEdit = true;

	}

	btnClickedHandler(_action) {
		this.params.context.componentParent.masterGridDetail(this.params.data, this.pageName);

	}

	ngOnDestroy() {
		// do nothing
	}
}